<template>
  <q-app>
    <q-layout view="lHh Lpr lFf">
      <q-header elevated>
        <q-toolbar>
          <q-btn
            flat
            dense
            round
            icon="menu"
            aria-label="Menu"
            @click="toggleLeftDrawer"
          />

          <q-toolbar-title>
            Gosnell Inventory
          </q-toolbar-title>

          <div>v2.0</div>
        </q-toolbar>
      </q-header>

      <q-drawer
        v-model="leftDrawerOpen"
        bordered
        class="bg-grey-1"
      >
        <q-list>
          <q-item-label header class="text-weight-bold text-uppercase">
            Inventory Management
          </q-item-label>

          <q-item
            v-for="p in appPages"
            :key="p.title"
            clickable
            :to="p.url"
            exact
            @click="leftDrawerOpen = false"
          >
            <q-item-section avatar>
              <q-icon :name="p.icon" />
            </q-item-section>

            <q-item-section>
              <q-item-label>{{ p.title }}</q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </q-drawer>

      <q-page-container>
        <router-view />
      </q-page-container>
    </q-layout>
  </q-app>
</template>

<script>
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'App',

  setup() {
    document.title = 'Gosnell Inventory'

    const leftDrawerOpen = ref(false)

    const appPages = [
      { title: 'Inventory List', url: '/home/Valentino', icon: 'list_alt' },
      { title: 'Types', url: '/types', icon: 'category' },
      { title: 'Locations', url: '/location', icon: 'place' },
      { title: 'Statuses', url: '/status', icon: 'assignment_turned_in' }
    ]

    return {
      appPages,
      leftDrawerOpen,
      toggleLeftDrawer() {
        leftDrawerOpen.value = !leftDrawerOpen.value
      }
    }
  }
})
</script>
